import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingCTA } from "@/components/FloatingCTA";

export const Layout = () => (
  <div className="min-h-screen bg-sand text-ink">
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <FloatingCTA />
  </div>
);
